import React from 'react';
import ProjectRole from '../ProjectRole';
import {
    MyTableCell1
} from "../../../../styling/Styles";

//  This component renders the cell of the row that is responsible for user's role info
const ProjectRoleCell = ({row, index, updateData, projectRole, setProjectRole, showStatus}) => 
    (
        <MyTableCell1
            align="center"
            style={
                index % 2 === 0
                ? null
                : { backgroundColor: "#CFD8E0" }
            }
            >
                { showStatus === true ?
                    <ProjectRole
                        project={row}
                        updateData={updateData}
                        projectRole={projectRole}
                        setProjectRole={setProjectRole}
                    />
                    :
                    <span style={{color: '#999999'}}>{projectRole}</span>
                }   
        </MyTableCell1>
    )

export default ProjectRoleCell;